module.exports = __webpack_public_path__ + "static/media/mainBg.fffc6355.jfif";